/* SEERAT v5.4.0 — Facticied */
/* Seerat free shipping progress bar.
   The markup is rendered by Liquid; this element only fills in the
   message and the bar width, so the theme needs no math in Liquid. */
(function () {
  'use strict';

  function formatAmount(cents, format) {
    var value = Math.abs(Math.round(cents)) / 100;
    var pattern = /\{\{\s*(\w+)\s*\}\}/;
    var match = (format || '${{amount}}').match(pattern);
    var token = match ? match[1] : 'amount';
    var decimals = token.indexOf('no_decimals') === -1 ? 2 : 0;
    var thousands = ',';
    var decimal = '.';

    if (token.indexOf('comma_separator') !== -1) {
      thousands = '.';
      decimal = ',';
    } else if (token.indexOf('apostrophe_separator') !== -1) {
      thousands = "'";
    } else if (token.indexOf('space_separator') !== -1) {
      thousands = ' ';
      decimal = token.indexOf('period_and_space') !== -1 ? '.' : ',';
    }

    var fixed = value.toFixed(decimals);
    var parts = fixed.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    var out = decimals && parts[1] ? whole + decimal + parts[1] : whole;

    return match ? (format || '').replace(pattern, out) : out;
  }

  class SeeratShipBar extends HTMLElement {
    connectedCallback() {
      this.render();
    }

    render() {
      var goal = Math.round(parseFloat(this.dataset.goal || '0') * 100);
      var total = parseInt(this.dataset.total || '0', 10) || 0;
      var textEl = this.querySelector('.seerat-ship__label');
      var fillEl = this.querySelector('.seerat-ship__fill');

      if (!goal || goal <= 0 || !textEl || !fillEl) {
        this.setAttribute('hidden', '');
        return;
      }

      var unlocked = total >= goal;
      var percent = unlocked ? 100 : Math.max(2, Math.round((total / goal) * 100));
      var remaining = formatAmount(goal - total, this.dataset.format);

      textEl.textContent = unlocked
        ? this.dataset.done || ''
        : (this.dataset.away || '').replace('[amount]', remaining);

      fillEl.style.width = percent + '%';
      this.classList.toggle('is-unlocked', unlocked);
      this.setAttribute('aria-valuenow', String(percent));
      this.removeAttribute('hidden');
    }
  }

  if (!customElements.get('seerat-ship-bar')) {
    customElements.define('seerat-ship-bar', SeeratShipBar);
  }
})();
